import { Box, Typography, Button } from '@mui/material';


const Header = () => {
    const invoicesNewPage = () => {
        window.location.href = '/invoices/new'; 
    };
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Typography variant="h3">Controle de faturas</Typography>
            <Button variant="contained" onClick={invoicesNewPage} sx={{maxWidth:'8rem'}}>
                Criar fatura
            </Button>
        </Box>
    );
};

export default Header;
